import React from "react";
import { connect } from "react-redux";
import { func } from "prop-types";
import { Divider, Header } from "semantic-ui-react";
import { getBreadcrumbPartials } from "../../../selectors/unit/navigation";
import { SubLineItemShape } from "../../configurator/roomBook.shape";

function BreadcrumbPartials({
  lastSubLineItem,
  subLineItem,
  makeBreadcrumbPartials
}) {
  const lastBreadcrumbPartials = lastSubLineItem
    ? makeBreadcrumbPartials({
        to: lastSubLineItem
      })
    : [];
  const breadcrumbPartials = makeBreadcrumbPartials({
    to: subLineItem
  });

  const renderSubSectionHeader =
    lastBreadcrumbPartials[1]?.key !== breadcrumbPartials[1]?.key;
  const renderLineItemHeader =
    lastBreadcrumbPartials[2]?.key !== breadcrumbPartials[2]?.key;
  const renderSubLineItemHeader =
    lastBreadcrumbPartials[3]?.key !== breadcrumbPartials[3]?.key;

  return (
    <>
      {renderSubSectionHeader && (
        <Divider horizontal>
          <Header className="subSectionHeader">
            {renderSubSectionHeader && breadcrumbPartials[1]?.content}
            <Header.Subheader>
              {breadcrumbPartials[0]?.content}
            </Header.Subheader>
          </Header>
        </Divider>
      )}
      {renderLineItemHeader && (
        <Header size="small" className="lineItemHeader">
          {breadcrumbPartials[2]?.content}
        </Header>
      )}
      {renderSubLineItemHeader && (
        <Header className="subLineItemHeader">
          <Header.Subheader>{breadcrumbPartials[3]?.content}</Header.Subheader>
        </Header>
      )}
    </>
  );
}

BreadcrumbPartials.propTypes = {
  subLineItem: SubLineItemShape.isRequired,
  lastSubLineItem: SubLineItemShape,
  makeBreadcrumbPartials: func.isRequired
};

BreadcrumbPartials.defaultProps = {
  lastSubLineItem: undefined
};

const mapStateToProps = state => {
  const makeBreadcrumbPartials = getBreadcrumbPartials(state);

  return {
    makeBreadcrumbPartials
  };
};

export default connect(mapStateToProps)(BreadcrumbPartials);
